<template>
    <ol class="breadcrumb page-breadcrumb" v-if="currentRouteName !== 'dashboard'">
        <li class="breadcrumb-item">
            <router-link :to="{ name: 'dashboard'}"  v-slot="{ href, navigate }">
                <a :href="href" @click="navigate" >Edutalk</a>
            </router-link>
        </li>
        <li class="breadcrumb-item" :key="`${i}-${breadcrumb.id}`" v-for="(breadcrumb, i) in breadcrumbs">
            <router-link
                    v-if="breadcrumb.route"
                    :key="i"
                    :to="{ name: breadcrumb.route }"
                    v-slot="{ href, navigate }">
                <a :href="href" @click="navigate" >{{ breadcrumb.title }}</a>
            </router-link>
            <span class="text-muted" :key="i" v-if="!breadcrumb.route">
                {{ breadcrumb.title }}
              </span>
        </li>

        <li class="position-absolute pos-top pos-right d-none d-sm-block"><span class="js-get-date">{{ now }}</span></li>
    </ol>
</template>

<script>
    import {mapGetters} from "vuex";
    export default {
        name: "EdutalkBreadcrumbs",
        data() {
            return {
                publicPath: process.env.VUE_APP_BASE_URL,
                now: null
            }
        },
        props: {
            breadcrumbs: Array,
            title: String
        },
        mounted() {
            this.now = this.$moment().format('dddd - D/M/Y');
        },
        computed: {
            ...mapGetters(["layoutConfig"]),
            currentRouteName() {
                return this.$route.name;
            }
        },
    };
</script>
